import { FiPackage, FiExternalLink } from 'react-icons/fi';

export default function Inventory() {
  return (
    <div className="p-4 sm:p-6">
      <h2 className="text-lg font-semibold text-slate-800 mb-4">Inventory</h2>

      <div className="bg-white rounded-xl border border-slate-200 p-8 flex flex-col items-center text-center gap-4">
        <div className="w-14 h-14 bg-blue-50 rounded-full flex items-center justify-center">
          <FiPackage size={28} className="text-blue-500" />
        </div>
        <div>
          <h3 className="font-semibold text-slate-800 mb-1">Full Inventory Dashboard</h3>
          <p className="text-sm text-slate-500 max-w-xs">
            Manage products, categories, sales, customers, and more from the kiosk inventory dashboard.
          </p>
        </div>
        <a
          href="/kiosk"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors"
        >
          <FiExternalLink size={15} />
          Open Inventory Dashboard
        </a>
      </div>
    </div>
  );
}
